import { render, staticRenderFns } from "./root-pogs-reports.vue?vue&type=template&id=2f3471f4&"
import script from "./root-pogs-reports.vue?vue&type=script&lang=js&"
export * from "./root-pogs-reports.vue?vue&type=script&lang=js&"
import style0 from "./root-pogs-reports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports